module.exports = __webpack_public_path__ + "res/29-img_bg_l.f8d387a7adc0e0bfad5a48d279403de0.png";